"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const Card = ({ surfaceColor, borderColor, borderRadius, dropShadow, children }) => {
    return (react_1.default.createElement(foundations_1.Box, { sx: {
            backgroundColor: surfaceColor
                ? surfaceColor
                : "surface-neutral-default",
            border: "1px solid",
            borderColor: borderColor ? borderColor : "stroke-neutral-tertiary",
            borderRadius: borderRadius ? borderRadius : "radius-2",
            boxShadow: dropShadow ? dropShadow : "none",
            width: "fit-content"
        } }, children));
};
exports.Card = Card;
//# sourceMappingURL=Card.js.map